import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ensures every route change lands the visitor at the top of the new page.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}